import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import type SubjectMembersListView from '@UI/Store/Subjects/Views/SubjectMembersListView';
import type SubjectUserView from '@UI/Store/Subjects/Views/SubjectUserView';

/** The users of the facility for one dossier, in the order the server sent them. */
class SubjectUsersListView {
	readonly typeKey: string;
	readonly subjectId: number;
	readonly users: readonly SubjectUserView[];

	constructor(typeKey: string, subjectId: number, users: readonly SubjectUserView[]) {
		this.typeKey = typeKey;
		this.subjectId = subjectId;
		this.users = users;

		Object.freeze(this);
	}

	isFor(subject: SubjectAddress): boolean {
		return this.typeKey === subject.typeKey && this.subjectId === subject.subjectId;
	}

	findById(userId: number): SubjectUserView | null {
		return this.users.find((user) => user.id === userId) ?? null;
	}

	/** The users who can be added: allowed to be members and not members yet. */
	candidates(members: SubjectMembersListView): readonly SubjectUserView[] {
		return this.users.filter((user) => user.canBeMember && !members.hasMember(user.id));
	}
}

export default SubjectUsersListView;
